/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullGoalDefinitionViewModel } from './FullGoalDefinitionViewModel'; 

export function getFullGoalDefinitionOptions(id: string, effectiveDate: string, onSuccess?: (result: FullGoalDefinitionViewModel) => void) {
	return queryOptions({
		queryKey: ['full-goal-definition', id, effectiveDate],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/getfullgoaldefinition/' + '?id=' + id + '&effectiveDate=' + effectiveDate;
			const resp = await axios.get<FullGoalDefinitionViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id) && Boolean(effectiveDate)
	});
}